export function decodeToken(token) {
  try {
    const payload = token.split('.')[1];
    return JSON.parse(atob(payload));
  } catch (e) {
    return null;
  }
}

export function isTokenExpired(token) {
  const decoded = decodeToken(token);
  if (!decoded || !decoded.exp) return true;

  const now = Date.now() / 1000;
  return decoded.exp < now;
}

export function getTokenExpiration(token) {
  const decoded = decodeToken(token);
  return decoded?.exp || null;
}

export function isTokenValid(token) {
  if (!token) return false;
  return !isTokenExpired(token);
}